export const demandKey = (departmentId, shiftId, date) =>
  `${departmentId}:${shiftId}:${date}`;

export const defaultKey = (departmentId, shiftId, weekday) =>
  `${departmentId}:${shiftId}:${weekday}`;

export const parseHeadcount = (value) => {
  if (value === "") return "";
  const parsed = Number.parseInt(value, 10);
  if (!Number.isFinite(parsed)) return "";
  return Math.max(0, Math.min(parsed, 999));
};

// "03.08.2026 – 09.08.2026" aus den Tagen der geladenen Woche.
export const formatWeekRange = (dates) => {
  const days = (Array.isArray(dates) ? dates : []).filter((day) => day?.date);
  if (!days.length) return "";
  const asLabel = (iso) => {
    const [year, month, day] = String(iso).split("-");
    return year && month && day ? `${day}.${month}.${year}` : String(iso);
  };
  return `${asLabel(days[0].date)} – ${asLabel(days[days.length - 1].date)}`;
};

export const hasAnyDemand = (values) =>
  Object.values(values || {}).some((value) => Number(value || 0) > 0);

export const shiftBreakLabel = (shift, t) => {
  const minutes = Number(shift?.break_duration_minutes || 0);
  if (!t) return minutes > 0 ? `${minutes} Min. Pause` : "Keine Pause";
  return minutes > 0
    ? t("demand_ui.break_minutes", { count: minutes })
    : t("demand_ui.break_none");
};
